module.exports = __webpack_public_path__ + "img/deliveryGray.09e0fb36.svg";